import React from 'react';
import { SttAlerta } from '@stt-componentes/core';
import { useSignals } from '@preact/signals-react/runtime';

/* @useSignals */
import { atualizacaoDisponivel } from '../signals/atualizacao';

const TITULO_PADRAO = 'Nova versão disponível';

// Aviso de nova versão do PWA (modo prompt). Ver docs/adr/0003-pwa-update-em-modo-prompt.md.
// "Atualizar" promove o SW em `waiting` (postMessage SKIP_WAITING) — o `controllerchange`
// registrado em src/index.js recarrega a página. "Depois" só fecha, mantendo o SW em `waiting`
// (não reabre até a próxima detecção / novo hash).
function AvisoAtualizacao() {
    useSignals();
    const aviso = atualizacaoDisponivel.value;

    if (!aviso.open) {
        return null;
    }

    const fechar = () => {
        atualizacaoDisponivel.value = { ...aviso, open: false };
    };

    const atualizar = () => {
        const waiting = aviso.registration?.waiting;
        if (waiting) {
            waiting.postMessage({ type: 'SKIP_WAITING' });
        } else {
            // Sem worker em waiting (caso de borda) — recarrega para pegar a versão nova.
            window.location.reload();
        }
    };

    const titulo = aviso.versao ? `Nova versão ${aviso.versao} disponível` : TITULO_PADRAO;

    const temNovidades = Array.isArray(aviso.novidades) && aviso.novidades.length > 0;
    const message = temNovidades ? (
        <>
            Uma nova versão do sistema foi publicada. Novidades desta versão:
            <ul>
                {aviso.novidades.map((novidade, indice) => (
                    <li key={indice}>{novidade}</li>
                ))}
            </ul>
        </>
    ) : (
        'Uma nova versão do sistema foi publicada. Clique em "Atualizar" para usar a versão mais recente.'
    );

    return (
        <SttAlerta
            open={aviso.open}
            title={titulo}
            message={message}
            type="confirmation"
            options={[
                {
                    title: 'Atualizar',
                    onClick: atualizar,
                },
                {
                    title: 'Depois',
                    onClick: fechar,
                },
            ]}
            onClose={fechar}
        />
    );
}

export default AvisoAtualizacao;
